import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { select } from '@ngrx/store';
import { take, takeUntil } from 'rxjs/operators';
import { AccountsState } from 'src/app/store/accounts.era';
import { Account } from '../../../../globals/store/accounts.data';
import { Program } from '../../../../globals/store/programs.data';
import { sleepForMS } from 'src/app/helpers/helpers';
import { Wrapper } from '../../components/wrapper.component';
import { CreateEventData } from '../../../../globals/store/events.data';
import { programsActions } from '../../store/programs.era';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { uiActions } from 'src/app/store/ui.era';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { DatePickerComponent } from 'src/app/components/misc/date-picker.component';
import { date2str, getDefaultTimeZoneDetails } from 'globals/helpers/helpers';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { AccountSelectorComponent } from 'src/app/components/wizards/account-selector.component'

@Component({
    selector: 'new-event-dialog',
    template: `
<div class="joi-dialog">
  <div mat-dialog-title>
    <span>New Event</span>
  </div>
  <div mat-dialog-content>
    <div *ngIf="!accounts.length" class="no-accounts">
      Before you start building your events, you need to make an account to put them in!
    </div>
    <div *ngIf="accounts.length">
      <div class="para">
        {{account_usage_message}}
      </div>
      <div *ngIf="can_create">
        <div class="para">
          Start by giving your event a name:
        </div>
        <mat-form-field class="general">
          <input matInput name="event_name" [(ngModel)]="event_name" placeholder="Event Name" (keydown.enter)="can_create && event_name && createEvent()">
        </mat-form-field>
      </div>
      <!-- TODO: account selector component -->
      <account-selector
        (initialAutoSelection)="delayedUseThisAccount($event)" 
        (dropdownSelection)="useThisAccount($event)" 
      ></account-selector>
      <div class="will_start_trial_message" *ngIf="will_start_trial">Note: Creating an event will start your 30 day free trial.</div>
      <div class="will_start_trial_message" *ngIf="has_no_events_but_no_power">
        You will need to contact the account owner 
        <!-- {{ use_account.owner | json }} -->
      </div>
      <div class="date">
        Give your event a starting date (you can change the date later if you need to):
      </div>
      <date-picker (onDateChange)="date = $event" [pickedDate]="this.date"></date-picker>
      <!--
      <div class="name">
        And a name for the first room/location of the event: (optional):
      </div>
      <mutating-input [object]="this" [prop]="'programName'" [placeholder]="'Room/location name'"></mutating-input>
      -->
    </div>
  </div>
  <div mat-dialog-actions class="lg">
    <button matButton (click)="dialogRef.close()">Cancel</button>
    <button matButton="filled" color="primary" *ngIf="can_create" [disabled]="!event_name" (click)="createEvent()">Create Event</button>
    <button mat-button color="primary" *ngIf="!can_create && accounts.length && !has_no_events_but_no_power" (click)="goToSubscriptions()">Get more events</button>
    <button mat-button color="primary" *ngIf="!can_create && !accounts.length" (click)="goToAccounts()">Create Account</button>
  </div>
</div>

  `,
    styles: [`
.joi-dialog .para { margin-bottom: 15px; }
.date { margin: 20px 0 -20px; }
.joi-dialog .flex { display: flex; }
.joi-dialog .label { font-size:11px; font-weight:bold; color:#999; text-transform:uppercase; padding-bottom: 5px; }
.joi-dialog .name { line-height: 21px; }
.joi-dialog .dropdown_label, .drop { display: flex; cursor: pointer; }
.joi-dialog .will_start_trial_message { position: relative; top: 15px; color: #999; font-style: italic; }
  `],
  imports: [ MatButtonModule, AccountSelectorComponent, DatePickerComponent, MatFormFieldModule,CommonModule, MatDatepickerModule, MatInputModule, FormsModule, ReactiveFormsModule, MatDatepickerModule, MatDialogModule],
    standalone: true,
})
export class NewEventDialogComponent extends Wrapper<NewEventDialogComponent> {

  event_name;
  use_account: Account
  accounts: Account[] = []
  can_create
  will_start_trial
  has_no_events_but_no_power
  date
  programName: string = ''
  gotEvent = false

  account_usage_message = '';

  constructor(public dialogRef: MatDialogRef<NewEventDialogComponent>) {
    super()
    console.log("Opening new event dialog...")
    this.store.pipe(select('accounts'), takeUntil(this.$destroy)).subscribe((accounts: AccountsState) => {
      this.accounts = Object.values(accounts.entities)
    })
  }

  delayedUseThisAccount(account: Account) {
    setTimeout(() => this.useThisAccount(account))
  }

  useThisAccount(account: Account) {
    // todo: make this account their default
    console.log("useThisAccount called: ", { account })
    this.use_account = account;
    // console.log({ use_account:this.use_account.id});
    if (!account) return;
/*     if (!from_init) { // I don't know why default account is being set to the first account the user is on.  Was this for old users?  If so, it seems like we no longer need it.  If it is for users with no account, don't we want to leave it empty until they create an account?
      // this.store.dispatch(new UpdateUserSetting('default_account', account.id))
      this.settings.saveUserSetting('default_account', account.id);
    } */
    // docket parse
    this.will_start_trial = false;
    this.has_no_events_but_no_power = false;
    const active_events = account.docket.tally || 0;
    const event_limit = account.docket.limit;
    this.account_usage_message = 'No events available.  ';
    const is_active = ['fresh', 'incomplete', 'custom', 'active', 'trial', 'beta'].indexOf(account.docket.status) > -1;
    this.can_create = false
    if (account.is_suspended || +account.docket?.days_remaining === 0) {
      this.account_usage_message += "This account is suspended.";
    } else if (!is_active) {
      this.account_usage_message += "This account is not active.";
    } else if (event_limit === null && is_active) {
      this.can_create = true;
      this.account_usage_message = '';
      if (account.docket.status === 'fresh') {
        this.will_start_trial = true;
      }
    } else if (event_limit <= active_events) {
      this.has_no_events_but_no_power = !account.is_admin && !account.is_exec;
      this.account_usage_message += "This account has used up the " + event_limit + " available event" + (event_limit === 1 ? '' : 's') + ".";
    } else {
      this.can_create = true;
      this.account_usage_message = 'This account has used '
        + active_events + ' of it\'s '
        + event_limit + ' active events';
    }
  }

  goToAccounts() {
    this.router.navigate(['/accounts/']);
    this.dialogRef.close();
  }

  goToSubscriptions() {
    console.log('this.use_account ', this.use_account);
    this.router.navigate(['/account/' + this.use_account.id]);
    this.dialogRef.close();
  }

  async createEvent() {
    this.store.dispatch(uiActions.updateUIItem('takeover_loading', 'event'))
    this.settingsService.saveUserSetting('default_account', this.use_account.id);
    this.dialogRef.close()
    
    try {
      const firstProgram: Partial<Program> = { title: this.programName || '' }
      if (this.date) firstProgram.date = date2str(this.date)
      const data: CreateEventData = {
        eventName: this.event_name || '',
        accountId: this.use_account.id,
        firstProgram,
        defaultTimezoneDetails: getDefaultTimeZoneDetails(),
      }
      console.log({ createEventData: data })
      const eventId = await this.eventService.createEvent(data)
      console.log({ eventId })
      await this.router.navigate(['event/build/' + eventId])

      this.subCallback(this.store.select('events', 'event'), event => {
        if (event && event.eventId === eventId) this.gotEvent = true
      })

      
      
      let tries = 0
      while (!this.gotEvent && tries < 500) {
        tries += 1
        if (tries % 100 === 99) console.log({ tries, gotEvent: this.gotEvent })
        await sleepForMS(10)
      }

      this.store.dispatch( programsActions.focusFirstProgram(true))

    } catch (response) {
      this.logService.error({
        file: 'dashboard.dialog.newEvent.component',
        function: 'openNewEventDialog() afterClose() event.createEvent()',
        message: 'There was an error creating this new event',
        response,
        error: new Error(),
        data: { event_name: this.event_name, accountId: this.use_account.id }
      }) 
    } finally {
      this.store.dispatch(uiActions.updateUIItem('takeover_loading', null))
    }
  }
}
